import React from 'react';

import { Container } from 'react-bootstrap';

import './StyleWarning.css';

export default () => (
  <Container>
    <div className="Warning">
      <div className="warning-code">500</div>
      <div className="warning-status">
        เกิดข้อผิดพลาด
        <span className="warning-blue"> :(</span>
      </div>
    </div>
  </Container>
);
